import { VERSION } from "./version";

export const environment = {
   production: true,
   isMobile: false,
   version: VERSION,
   apiUrlBase: 'https://api.monific.com/v1',
   GOOGLE_RECAPTCHA_SITE_KEY: '6LeCzL0UAAAAAGnJAiu8wZSzR5TZTDcxwrFmVOiu',
   FIREBASE_VAPID_KEY: "BAS4yxebKaK1qmRPFEDH-c000Y7bZ_t5asxk0nZv3NcL50sumGrOIg_VowmVzkY2I0ERN0Vk7ZzlGTZKe3dcSG8",
   /** CONFIGURACIÓN PARA APLICACIÓN ANALYTICS EN FIREBASE */
   FIREBASE_CONFIG: {
      apiKey: 'AIzaSyDGOVjoiC8RACkwC0Ju9lfyyCnaqltADYo',
      authDomain: 'monific-28e73.firebaseapp.com',
      databaseURL: 'https://monific-28e73.firebaseio.com',
      projectId: 'monific-28e73',
      storageBucket: 'monific-28e73.appspot.com',
      messagingSenderId: '1094241711490',
      appId: '1:1094241711490:web:a1af562bbb5c2983808b9b',
      measurementId: 'G-16RYQ21V6N'
   },
};
